module.exports = __webpack_public_path__ + "static/7skillstechniquesba@2x-c1c4760315534b115b34d0abef02ae2a.jpg";